// 1. 외부 패키지
import axios, { CancelTokenSource } from 'axios'
import { selectorFamily } from 'recoil'


// 2. 프로젝트 내부 alias


// 3. 상대 경로
import API from '../service/api'
import {
  GetDetailResponseDataModel
} from '../service/basic/model/get-detail-response-model'


// 4. 타입
import { YNType } from '../shared/types'


let cancel_token: CancelTokenSource | null = null;

interface DetailModel extends GetDetailResponseDataModel {
  title: string;
  bunyang_status: string;
  project_period: string;
  price_bunyang_txt: string;
  complete_ymd: string;
}

interface PersonalModel {
  fave_yn: YNType
}

interface BrokerModel {
  homepage: string;
  tel: string;
}

export interface NoticeModel {
  original_name: string;
  path: string;
}

interface OverviewModel {
  name: string;
  type: string;
  design_status: string;
  route_status: string;
  address: string;
  business_schedule: string;
  avg_route_price: number | null;
  set_date: string;
  set_area: number | null;
  route_rate: number | null;
  accept_date: string;
  work_end_date: string;
  corp: string;
  organize: string;
}

type PurposeType = {
  sandan_id: string;
  purpose: string;
}

type AttractType = {
  sandan_id: string;
  work_type_id: string;
  name: string;
  m_contents: string;
  m_name: string;
}

interface GetBasicDetailReponseModel {
  detail: DetailModel;
  personal: PersonalModel;
  preview: Array<string>;
  broker: BrokerModel;
  notice: Array<NoticeModel>;
  overview: OverviewModel;
  purpose: Array<PurposeType>;
  attract_type: Array<AttractType>;
}

const get_basic_detail_selector = selectorFamily<
  GetBasicDetailReponseModel,
  string
>({
  key: '@basic/get_basic_detail_selector',
  get: (idx: string) => async () => {

    if (idx === '' || idx == null) {
      alert('조회할 수 없는 정보입니다.');
      return;
    }

    if (cancel_token) cancel_token.cancel();

    cancel_token = axios.CancelToken.source();

    try {
      const response = await API.basic
        .getDetail(parseInt(idx), cancel_token.token);
      const data = response?.data;
      return data;
    } catch (error: any) {
      console.error('에러 응답: ', error.response.data.msg);
      return error.response.data;
    }
  },
})

export default get_basic_detail_selector